/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierStoreOrderVariance
 */
export interface SupplierStoreOrderVariance {
    /**
     * 
     * @type {string}
     * @memberof SupplierStoreOrderVariance
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierStoreOrderVariance
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierStoreOrderVariance
     */
    supplierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierStoreOrderVariance
     */
    storeName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierStoreOrderVariance
     */
    kind: SupplierStoreOrderVarianceKindEnum;
    /**
     * 
     * @type {number}
     * @memberof SupplierStoreOrderVariance
     */
    averageIntervalDays: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierStoreOrderVariance
     */
    daysSinceLastOrder: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierStoreOrderVariance
     */
    daysOverdue: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierStoreOrderVariance
     */
    thresholdDays: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierStoreOrderVariance
     */
    thresholdPercent: SupplierStoreOrderVarianceThresholdPercentEnum;
    /**
     * 
     * @type {number}
     * @memberof SupplierStoreOrderVariance
     */
    orderCount: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierStoreOrderVariance
     */
    lastOrderId: string;
    /**
     * 
     * @type {Date}
     * @memberof SupplierStoreOrderVariance
     */
    lastOrderCreatedAt: Date;
}


/**
 * @export
 */
export const SupplierStoreOrderVarianceKindEnum = {
    OverdueOrder: 'OVERDUE_ORDER'
} as const;
export type SupplierStoreOrderVarianceKindEnum = typeof SupplierStoreOrderVarianceKindEnum[keyof typeof SupplierStoreOrderVarianceKindEnum];

/**
 * @export
 */
export const SupplierStoreOrderVarianceThresholdPercentEnum = {
    NUMBER_30: 30,
    NUMBER_50: 50,
    NUMBER_75: 75,
    NUMBER_100: 100
} as const;
export type SupplierStoreOrderVarianceThresholdPercentEnum = typeof SupplierStoreOrderVarianceThresholdPercentEnum[keyof typeof SupplierStoreOrderVarianceThresholdPercentEnum];


/**
 * Check if a given object implements the SupplierStoreOrderVariance interface.
 */
// @ts-ignore
export function instanceOfSupplierStoreOrderVariance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "storeId" in value;
    isInstance = isInstance && "kind" in value;
    isInstance = isInstance && "averageIntervalDays" in value;
    isInstance = isInstance && "daysSinceLastOrder" in value;
    isInstance = isInstance && "daysOverdue" in value;
    isInstance = isInstance && "thresholdDays" in value;
    isInstance = isInstance && "thresholdPercent" in value;
    isInstance = isInstance && "orderCount" in value;
    isInstance = isInstance && "lastOrderId" in value;
    isInstance = isInstance && "lastOrderCreatedAt" in value;

    return isInstance;
}

// @ts-ignore
export function SupplierStoreOrderVarianceFromJSON(json: any): SupplierStoreOrderVariance {
    return SupplierStoreOrderVarianceFromJSONTyped(json, false);
}

// @ts-ignore
export function SupplierStoreOrderVarianceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierStoreOrderVariance {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplierId': json['supplier_id'],
        'storeId': json['store_id'],
        'supplierName': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'storeName': !exists(json, 'store_name') ? undefined : json['store_name'],
        'kind': json['kind'],
        'averageIntervalDays': json['average_interval_days'],
        'daysSinceLastOrder': json['days_since_last_order'],
        'daysOverdue': json['days_overdue'],
        'thresholdDays': json['threshold_days'],
        'thresholdPercent': json['threshold_percent'],
        'orderCount': json['order_count'],
        'lastOrderId': json['last_order_id'],
        'lastOrderCreatedAt': (new Date(json['last_order_created_at'])),
    };
}

// @ts-ignore
export function SupplierStoreOrderVarianceToJSON(value?: SupplierStoreOrderVariance | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplier_id': value.supplierId,
        'store_id': value.storeId,
        'supplier_name': value.supplierName,
        'store_name': value.storeName,
        'kind': value.kind,
        'average_interval_days': value.averageIntervalDays,
        'days_since_last_order': value.daysSinceLastOrder,
        'days_overdue': value.daysOverdue,
        'threshold_days': value.thresholdDays,
        'threshold_percent': value.thresholdPercent,
        'order_count': value.orderCount,
        'last_order_id': value.lastOrderId,
        'last_order_created_at': (value.lastOrderCreatedAt.toISOString()),
    };
}

